module.exports = __webpack_public_path__ + "img/golden_shrine_of_justice_small.5235ff8b.png";